import React from "react";

const LoadingSpinnerComponent: React.FC = () => {
  return (
    <div className="d-flex justify-content-center">
      <div
        className="spinner-border text-primary"
        id="locationsSpinner"
        role="status"
      ></div>
    </div>
  );
};

export default LoadingSpinnerComponent;
